<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-table"></i>
        System Pattern
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">management</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">System Pattern</a>
        </li>
      </ul>
    </div>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto">
              Pattern Detail
            </div>
            <div class="mb7">
              <label class="switch switch-sm switch-text switch-info mb-0">
                <input type="checkbox" class="switch-input" v-model="model.is_use" id="ph_use">
                <span class="switch-label" data-on="On" data-off="Off"></span>
                <span class="switch-handle"></span>
              </label>
            </div>
          </div>
          <hr>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="is_use_true">Status</label>
            </b-col>
            <b-col class="col-xl-10 col-md-12">
              <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox" name="Active" id="Active" v-model="model.is_alive" :disabled="lock">
                <div class="checkbox-animate disabled">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_type">Category</label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
              <b-form-select v-if="codes.code_category[model.category]" v-model="model.category" :options="codes.code_category" :disabled="lock"></b-form-select>
              <b-form-input v-else :disabled="true" v-model="model.category"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_ext">Ext</label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
              <b-form-select v-if="codes.code_ext[model.ext]" v-model="model.ext" :options="codes.code_ext" :disabled="lock"></b-form-select>
              <b-form-input v-else :disabled="true" v-model="model.ext"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <!-- <label class="col-form-label" for="ph_type">Type : {{model && model.type}}</label> -->
              <label class="col-form-label" for="ph_type">Type</label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
              <b-form-select v-model="model.type" :options="codes.code_type" :disabled="lock"></b-form-select>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_code">Code</label>
            </b-col>
            <b-col class="col-xl-10 col-md-12">
              <b-form-input md=5 type="text" id="ph_code" v-model="model.code" :disabled="lock"></b-form-input>
            </b-col>
          </b-row>
          <!-- <b-form-group>
            <label for="ph_description">Description</label>
            <b-form-textarea :rows="3" v-model="model.description" id="ph_description" :disabled="lock"></b-form-textarea>
          </b-form-group> -->
          <b-button class="mt-4" size="sm" variant="warning" :disabled="model.is_del" @click="edit"> Edit </b-button>
          <b-button class="mt-4" size="sm" variant="danger" :disabled="model.is_del" @click="confirm = true"> Remove </b-button>
          <b-button class="mt-4 float-right" size="sm" variant="primary" @click="list"> List </b-button>
        </b-card>
      </b-col>
    </b-row>
  <b-modal title="Deletion of information"  class="modal-danger" v-model="confirm" @ok="remove" ok-variant="outline-danger" cancel-variant="outline-dark" header-bg-variant="danger">
  Would you Like to Remove System Pattern?
  </b-modal>
</div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>